/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import ReservationEditView from '../../view/pages/reservations/ReservationEditView'
import ReservationEditStore from '../../store/reservation/ReservationEditStore'
import ReservationStore from '../../store/reservation/ReservationStore'
import SessionStore from '../../store/SessionStore'
import RoomOptionsStore from '../../store/options/RoomOptionsStore'
import ReservationAction from '../../action/reservation'
import ToolbarStore from '../../store/reservation/ToolbarStore'
import InvoiceAutomationStore from '../../store/invoice_automation/InvoiceAutomationStore'
import InvoiceAutomationAction from '../../action/invoice_automation'
import UserAction from '../../action/user'
import SiteReferrerNameOptionsStore from '../../store/options/SiteReferrerNameOptionsStore'
import SiteReferrerAction, { SiteReferrerAvailableType } from '../../action/site_referrer'

class ReservationEditContainer extends Component {
  static getStores() {
    return [ReservationEditStore, ReservationStore, RoomOptionsStore, InvoiceAutomationStore, SessionStore, ToolbarStore, SiteReferrerNameOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      state: ReservationEditStore.getState(),
      reservation: ReservationStore.getState(),
      room_options: RoomOptionsStore.getState(),
      invoice_automation: InvoiceAutomationStore.getState(),
      session: SessionStore.getState(),
      toolbar: ToolbarStore.getState(),
      site_referrer_options: SiteReferrerNameOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    // ReservationDetail
    const id = this.state.match.params.id

    if (id) {
      ReservationAction.showDetail(id)
    }

    UserAction.fetchUserRooms()
    InvoiceAutomationAction.fetchOne()
    SiteReferrerAction.fetchSiteReferrers(SiteReferrerAvailableType.RESERVATION)
  }

  render() {
    return ReservationEditView(this.state)
  }
}

export default withRouter(Container.create(ReservationEditContainer, { withProps: true }))
